export default "__VITE_ASSET__73c30f17__"